import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "godDoUser" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "inner" }
const _hoisted_5 = { class: "list" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_12 = { class: "modal" }

import { ref, onMounted } from 'vue'
import axios from '@/api/notice' // axios 인스턴스 경로 확인
import Header from '@/components/admin/adminHeader.vue'
import Sidebar from '@/components/admin/adminSidebar.vue'
import NoticeInsertModal from '@/components/admin/insertNotice.vue' // 새로 만든 모달 컴포넌트 임포트


export default /*@__PURE__*/_defineComponent({
  __name: 'noticeList',
  setup(__props) {

const isModalOpen = ref(false) // 기존 수정 모달 가시성
const isInsertModalOpen = ref(false) // 새로운 등록 모달 가시성
const editData = ref({ no: 0, title: '', content: '' })
const userList = ref<any[]>([])

const openEditModal = (user: any) => {
  editData.value = { ...user }
  isModalOpen.value = true
}

// 수정 모달 닫기
const closeModal = () => {
  isModalOpen.value = false
}

// 공지 수정
const updateNotice = async () => {
  try {
    await axios.updateNotice({
      no: editData.value.no,
      title: editData.value.title,
      content: editData.value.content
    })
    alert('수정되었습니다.')
    closeModal()
    fetchNoticeList() // 다시 불러오기
  } catch (err) {
    console.error('공지 수정 실패', err)
    alert('수정 중 오류가 발생했습니다.')
  }
}

// 공지 삭제
const deleteNotice = async (no: number) => {
  if (!confirm('정말 삭제하시겠습니까?')) return
  try {
    await axios.deleteNotice(no)
    alert('삭제되었습니다.')
    fetchNoticeList()
  } catch (err) {
    console.error('삭제 실패', err)
    alert('삭제 중 오류가 발생했습니다.')
  }
}

const fetchNoticeList = async () => {
  try {
    const res = await axios.ListNotice()
    console.log(res.data)
    userList.value = res.data
  } catch (err) {
    console.error(err)
  }
}

const formatDate = (dateStr: string) => {
  return new Date(dateStr).toLocaleString()
}

onMounted(() => {
  fetchNoticeList()
})

// === 공지사항 등록 모달 관련 함수 ===
const openInsertModal = () => {
  isInsertModalOpen.value = true
}

const closeInsertModal = () => {
  isInsertModalOpen.value = false
}

const handleNoticeAdded = () => {
  fetchNoticeList() 
}
// ===================================

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Header),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Sidebar),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, [
              _createElementVNode("h2", null, "공지사항 목록")
            ], -1)),
            _createElementVNode("div", { style: {"display":"flex","justify-content":"end","width":"1300px"} }, [
              _createElementVNode("button", {
                class: "button",
                onClick: openInsertModal
              }, " 등록 ")
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("table", null, [
                _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { style: {"width":"5%"} }, " 번호 "),
                    _createElementVNode("th", { style: {"width":"15%"} }, " 제목 "),
                    _createElementVNode("th", { style: {"width":"55%"} }, " 내용 "),
                    _createElementVNode("th", { style: {"width":"15%"} }, " 등록일자 "),
                    _createElementVNode("th", { style: {"width":"5%"} }),
                    _createElementVNode("th", { style: {"width":"5%"} })
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (userList.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_6, _cache[2] || (_cache[2] = [
                        _createElementVNode("td", { colspan: "8" }, " 조회된 데이터가 없습니다. ", -1)
                      ])))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userList.value, (user) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: user.no
                    }, [
                      _createElementVNode("td", null, _toDisplayString(user.no), 1),
                      _createElementVNode("td", null, _toDisplayString(user.title), 1),
                      _createElementVNode("td", null, _toDisplayString(user.content), 1),
                      _createElementVNode("td", null, _toDisplayString(formatDate(user.createdAt)), 1),
                      (user.userAuth !== 'ROLE_ADMIN')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                            _createElementVNode("button", {
                              class: "updateBtn",
                              onClick: ($event: any) => (openEditModal(user))
                            }, " 수정 ", 8, _hoisted_8)
                          ]))
                        : _createCommentVNode("", true),
                      (user.userAuth !== 'ROLE_ADMIN')
                        ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                            _createElementVNode("button", {
                              class: "deleteBtn",
                              onClick: ($event: any) => (deleteNotice(user.no))
                            }, " 삭제 ", 8, _hoisted_10)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (isModalOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[5] || (_cache[5] = _createElementVNode("h3", null, "공지사항 수정", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("label", null, "제목", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editData.value.title) = $event)),
              type: "text"
            }, null, 512), [
              [_vModelText, editData.value.title]
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("label", null, "내용", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editData.value.content) = $event))
            }, null, 512), [
              [_vModelText, editData.value.content]
            ]),
            _createElementVNode("div", { class: "modal-buttons" }, [
              _createElementVNode("button", { onClick: updateNotice }, " 저장 "),
              _createElementVNode("button", { onClick: closeModal }, " 닫기 ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (isInsertModalOpen.value)
      ? (_openBlock(), _createBlock(NoticeInsertModal, {
          key: 1,
          onClose: closeInsertModal,
          onNoticeAdded: handleNoticeAdded
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})